import { render, staticRenderFns } from "./StocktakingProfitAndLossAdd.vue?vue&type=template&id=1236d289&scoped=true&"
import script from "./StocktakingProfitAndLossAdd.vue?vue&type=script&lang=js&"
export * from "./StocktakingProfitAndLossAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1236d289",
  null
  
)

export default component.exports